<template>
  <div class="container">
    <crumb :prevLevel="prevLevel" current="视频监控" />
    <div class="search">
      <el-form label-width="120px">
        <el-row>
          <el-col :span="6">
            <el-form-item :label="enterpriseType + '企业名称'">
              <el-input
                :placeholder="`请输入${enterpriseType}企业名称`"
                v-model="entName"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="监测点类型">
              <el-select v-model="monitorType">
                <el-option label="全部" value="" />
                <el-option label="视频监控" value="video" />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item label="监测点名称">
              <el-input
                placeholder="请输入监测点名称"
                v-model="videoChannelDesc"
              />
            </el-form-item>
          </el-col> -->
          <el-col :span="6">
            <el-form-item label-width="0">
              <el-button
                type="primary"
                style="margin-left:20px"
                @click="initQuery"
                >查询</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="statistic">
      <div class="title">数据监控点数量统计</div>
      <div class="content">
        <div class="num-list">
          <div class="num-item">
            <div class="num">{{ entCount }}</div>
            <div class="text">{{ enterpriseType }}企业数量</div>
          </div>
          <div class="num-item">
            <div class="num">{{ monitorCount }}</div>
            <div class="text">环境监测点数量</div>
          </div>
        </div>
        <Echarts :echartsOption="echartsOption" />
      </div>
    </div>
    <div class="table-list">
      <div class="title">数据监控点列表</div>
      <el-table :data="monitorList" class="table">
        <el-table-column
          prop="organName"
          :label="enterpriseType + '企业名称'"
        />
        <el-table-column prop="monitor_type" label="监测点类型" />
        <el-table-column prop="monitor_count" label="监测点数目" />
        <!-- <el-table-column prop="video_channel_desc" label="监测点名称" /> -->
        <el-table-column prop="available" label="是否可用">
          <template slot-scope="scope">
            <span class="available" v-if="scope.row.available === '2'"
              >可用</span
            >
            <span class="unavailable" v-else>不可用</span>
          </template>
        </el-table-column>
        <el-table-column label="监测点详情">
          <template slot-scope="scope">
            <el-button
              type="text"
              style="font-size: 12px"
              :disabled="scope.row.available === '1'"
              @click="loadVideoList(scope.row)"
              >查看详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        layout="total, prev, pager, next, jumper"
        :total="total"
        :current-page="currentPage"
        @current-change="loadMonitorListForLogin"
        :page-size="5"
      />
    </div>
    <div
      ref="dialogWrapper"
      :class="[{ 'dialog-wrapper': true }, { leave: showFlag }]"
    >
      <el-row class="bg-f">
        <h1 class="title">视频列表</h1>
        <i class="close el-icon-close" @click="closeVideo"></i>
        <!-- <h1 class="" >X</h1> -->
        <WebVideo :channelList="channelList" :loginIp="loginIp" />
      </el-row>
    </div>
  </div>
</template>

<script>
import WebVideo from 'components/web-video/web-video';
import Echarts from 'components/echarts/echarts';
import Crumb from 'components/crumb/crumb';
import enterpriseTypeMixin from './enterprise-type.mixin';
import webVideoMixin from 'mixin/web-video';

const WebVideoCtrl = window.WebVideoCtrl;

export default {
  data() {
    return {
      entType: '',
      entName: '',
      monitorType: '',
      videoChannelDesc: '',
      entCount: '',
      monitorCount: '',
      echartsOption: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisTick: {
              show: false,
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              show: false
            },
            minInterval: 1
          }
        ],
        series: [
          {
            name: '监测点数量',
            type: 'bar',
            barWidth: '27px',
            itemStyle: {
              color: '#386CE2'
            },
            data: []
          }
        ]
      },
      monitorList: [],
      currentPage: 1,
      total: 0,
      channelList: [],
      loginIp: '',
      showFlag: false
    };
  },
  mixins: [enterpriseTypeMixin, webVideoMixin],
  mounted() {
    this.initQuery();
  },
  methods: {
    initQuery() {
      if (this.enterpriseType === '生产') {
        this.entType = this.$common.entType.production;
      } else {
        this.entType = this.$common.entType.circulate;
      }
      this.loadChartsData();
      this.loadMonitorListForLogin(1);
    },
    loadChartsData(currentPage) {
      this.$request({
        url: 'rest/circulation/dataMonitorStatics',
        data: {
          json: JSON.stringify({
            params: {
              entName: this.entName,
              entType: this.entType,
              videoChannelDesc: this.videoChannelDesc
            }
          })
        }
      }).then(res => {
        this.entCount = res.entNum;
        this.monitorCount = res.dataMonitorNum;
        const list = res.list;
        const xData = [];
        const yData = [];
        list.forEach(item => {
          xData.push(item.organ_name);
          yData.push(item.channel_num);
        });
        this.echartsOption.xAxis[0].data = xData;
        this.echartsOption.series[0].data = yData;
      });
    },
    loadMonitorListForLogin(currentPage) {
      this.currentPage = currentPage;
      this.$request({
        url: 'rest/entVideoInfo/queryEntList',
        data: {
          json: JSON.stringify({
            pageBean: {
              pageNum: this.currentPage,
              pageSize: 5
            },
            params: {
              entName: this.entName,
              entType: this.entType,
              handlerName: 'ent_info_list'
            }
          })
        }
      }).then(res => {
        res.list.forEach(item => {
          this.videoLogin(
            {
              loginIp: item.videoList[0]
                ? item.videoList[0].videoIp
                : '192.168.20.101',
              loginPort: item.videoList[0] ? item.videoList[0].videoPort : '80',
              userName: item.videoList[0] ? item.videoList[0].user : 'admin',
              password: item.videoList[0]
                ? item.videoList[0].passWord
                : '123456789o',
              id: item.id
            },
            () => {}
          );
        });
        setTimeout(() => {
          this.loadMonitorList();
        }, 1000);
      });
    },
    loadMonitorList() {
      this.$request({
        url: 'rest/entVideoInfo/queryEntList',
        data: {
          json: JSON.stringify({
            pageBean: {
              pageNum: this.currentPage,
              pageSize: 5
            },
            params: {
              entName: this.entName,
              entType: this.entType,
              handlerName: 'ent_info_list'
            }
          })
        }
      }).then(res => {
        res.list.forEach(item => {
          item.channelList = this.channelListMap[item.id]
            ? this.channelListMap[item.id].map(item => {
                return item.id;
              })
            : [];
          const channelList = [];
          if (item.videoList[0]) {
            item.videoList[0].videoChannelList.map(innerItem2 => {
              /* 此处最开始取得是最新视频登录后返回的通道与后台返回通道的交集，但由于列表中新增了监测点数量所以此处暂时不取交集直接取后台返回的数据
               */

              // if (item.channelList.indexOf(innerItem2.videoChannel) > -1) {
              channelList.push({
                id: innerItem2.videoChannel,
                currentName: innerItem2.videoChannelDesc
              });
              // }
            });
          }
          if (channelList.length === 0) {
            item.availableChannelList = [];
            item.available = '1';
          } else {
            item.availableChannelList = channelList;
            item.available = '2';
          }
        });
        this.monitorList = res
          ? res.list.map(item => ({
              ...item,
              monitor_count: item.availableChannelList.length,
              monitor_type: '视频监控'
            }))
          : [];
        this.total = res ? res.total : 0;
      });
    },
    loadVideoList(row) {
      this.showFlag = true;
      this.loginIp = row.videoList[0].videoIp;
      this.channelList = row.availableChannelList;
    },
    closeVideo() {
      this.showFlag = false;
      WebVideoCtrl.I_Stop();
    }
  },
  components: {
    Echarts,
    Crumb,
    WebVideo
  }
};
</script>

<style lang="stylus" scoped>
@import './common.styl'
.dialog-wrapper
  position fixed
  left 100%
  right 0
  top 0
  bottom 0
  background rgba(0,0,0,.5)
  z-index 101
  &.leave
    left 0
  .bg-f
    width 1200px
    margin 50px auto 0 auto
    background #fff
    padding 50px
    padding-top 70px
    position relative
    .title
      position absolute
      left 15px
      top 15px
    .close
      position absolute
      right 15px
      top 15px
      cursor pointer
      &:hover
        color #409EFF
.available
  color rgb(64, 158, 255)
.unavailable
  color #aaa
</style>
